<template>
    <modal
      id="p-list-representation-record-modal"
      class="p-list-representation-record-modal"
      size="800px"
      :show.sync="show"
      :footer="false"
    >
        <Loader class="w-100" :loading="loading">
            <div class="p-list-representation-record-modal-content w-100 row">
                  <div class="form-group d-flex flex-wrap w-100 justify-content-center mb-0 col-10 mr-auto ml-auto">
                      <form @submit.prevent="submit" class="row w-100">
                            <div class="d-flex w-100 align-items-center flex-column mb-3" >
                              <label class="ml-3 p-list-representation-label-text mb-2">
                                ساعت شروع
                              </label>
                             <div class="row align-items-center mb-3 col-lg-8">
                                <selectTime @selectedDate="setStartTime" />
                            </div>
                            </div>
                            <div class="d-flex w-100 align-items-center flex-column mb-3" >
                              <label  for="namyFamily " class="ml-3 p-list-representation-label-text mb-2">
                                ساعت پایان
                              </label>
                            <div class="row align-items-center mb-3 col-lg-8">
                                <selectTime @selectedDate="setEndTime" />
                            </div>
                            </div>
                            <button type="submit" class="btn btn-primary btn-blue btn-sm col-4 mr-auto ml-auto">ثبت</button>
                      </form>
                  </div>
            </div>
        </Loader>
    </modal>
</template>

<script>
import selectTime from './selectTime'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'modalCreateSalon',
  components: {
    selectTime
  },
  props: {
    active: { type: [Boolean, Number], default: false },
    loading: { type: Boolean, default: false },
    hallId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      formData: {
        start_time: null,
        end_time: null
      }
    }
  },
  validations: {
    formData: {
      end_time: {
        required
      },
      start_time: {
        required
      }

    }
  },
  computed: {
    show: {
      set (val) {
        this.$emit('update:active', !!val)
      },
      get () {
        return !!this.active
      }
    }
  },
  methods: {
    setStartTime (payload) {
      this.formData.start_time = payload
    },
    setEndTime (payload) {
      this.formData.end_time = payload
    },
    submit () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$message.error('لطفا اطلاعات خود را بررسی کنید')
        return
      }

      this.$emit('updateLoading', true)
      this.formData.hall_id = this.hallId
      this.$store.dispatch('managementTodaySalon/createSans', this.formData)
        .then(res => {
          if (res.is_successful) {
            // hide modal
            this.show = false
            // reload sans list
            this.$emit('getSans')
          }
        })
        .catch(() => {
          // show error
          this.$message.error('لطفا اطلاعات خود را بررسی کنید')
        })
        .then(() => {
          this.$emit('updateLoading', false)
        })
    }
  }
}
</script>
